'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = require('reselect');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var menuSelector = exports.menuSelector = (0, _reselect.createSelector)(function (state) {
  return state.order.menu;
}, function (menuData) {
  if (!menuData) {
    return {};
  }

  var data = menuData.categories.reduce(function (acc, cat, index) {
    var items = cat.items.length;
    if (items === 0) {
      return acc;
    }
    return {
      // count items in the category and the section itself
      itemsCount: acc.itemsCount + cat.items.length + 1,
      categoriesCollapsed: [].concat(_toConsumableArray(acc.categoriesCollapsed), [{ name: cat.name, description: cat.description, index: index, items: items }]),
      itemsGrouped: _extends({}, acc.itemsGrouped, _defineProperty({}, cat.name, cat.items)),
      lookup: _extends({}, acc.lookup, _defineProperty({}, cat.name, acc.categoriesCount)),
      categoriesCount: acc.categoriesCount + 1
    };
  }, {
    categoriesCount: 0,
    itemsCount: 0,
    categoriesCollapsed: [],
    itemsGrouped: {},
    lookup: {}
  });
  return data;
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/selectors/menu.js
// module id = 418
// module chunks = 0